const DEFAULT_LANGUAGE = 'en-US';

const LANGUAGE_MAP = {
  'en-US': 'en-US',
  en: 'en-US',
  'zh-CN': 'zh-CN',
  zh: 'zh-CN',
  'zh-TW': 'zh-TW',
  'vi-VN': 'vi-VN',
  vi: 'vi-VN',
  'id-ID': 'id-ID',
  id: 'id-ID',
  'ms-MY': 'ms-MY',
  ms: 'ms-MY',
  'th-TH': 'th-TH',
  th: 'th-TH',
};

export { DEFAULT_LANGUAGE };

export function normalizeLanguage(language, fallback = DEFAULT_LANGUAGE) {
  if (!language || typeof language !== 'string') return fallback;
  return LANGUAGE_MAP[language.trim()] || fallback;
}

// 地址上的 lang 在主包执行时就能用。没有时再用 index.html 已经问到的语言。
function readInitialLanguage() {
  if (typeof window === 'undefined') return DEFAULT_LANGUAGE;
  try {
    const fromUrl = normalizeLanguage(new URLSearchParams(window.location.search).get('lang'), null);
    if (fromUrl) return fromUrl;
  } catch (e) {
    // ignore
  }
  return normalizeLanguage(window.__appLanguage, DEFAULT_LANGUAGE);
}

let currentLanguage = readInitialLanguage();

try {
  localStorage.removeItem('appLanguage');
} catch (e) {
  // ignore
}

export function setRequestLanguage(language) {
  currentLanguage = normalizeLanguage(language);
  return currentLanguage;
}

export function getRequestLanguage() {
  return currentLanguage;
}
